import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'full',
      component: resolve => require(['@/pages/index'], resolve),
      redirect: '/senderManage',
      children: [
        {
          path: '/senderManage',
          name: 'senderManage',
          component: resolve => require(['@/pages/senderManage/index'], resolve)
        }, {
          path: '/tokenManage',
          name: 'tokenManage',
          component: resolve => require(['@/pages/tokenManage/index'], resolve)
        }, {
          path: '/smtpManage',
          name: 'smtpManage',
          component: resolve => require(['@/pages/smtpManage/index'], resolve)
        }, {
          path: '/blackWhite',
          name: 'blackWhite',
          component: resolve => require(['@/pages/blackWhite/index'], resolve)
        }, {
          path: '/operateLogs',
          name: 'operateLogs',
          component: resolve => require(['@/pages/operateLogs/index'], resolve)
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js